module.exports = __webpack_public_path__ + "static/img/ljfl_1.975df8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/mainBusiness/ljfl_1.png
// module id = jVr8
// module chunks = 0